<template>
    <div class="task-center">
        <div class="task-center_tab">
            <div
                :class="['tab-item', { active: currentTab === tab.value }]"
                v-for="tab in tabList"
                :key="tab.value"
                @click="handleChangeTab(tab)"
            >
                {{ tab.label }}
            </div>
        </div>

        <div class="task-center_container">
            <!-- tab-过滤选择 -->
            <div class="container-top">
                <div class="top-filter status">
                    <div class="filter-item">
                        <div class="filter-item_label">需求状态：</div>

                        <div class="filter-item_check">
                            <div
                                :class="['check-item', { active: item.value === filter.status }]"
                                v-for="item in statusList"
                                :key="item.value"
                                @click="handleChangeFilter('status', item.value)"
                            >
                                {{ item.label }}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="top-filter mode">
                    <div class="filter-item">
                        <div class="filter-item_label">合作方式：</div>

                        <div class="filter-item_check">
                            <div
                                :class="['check-item', { active: item.value === filter.mode }]"
                                v-for="item in modelist"
                                :key="item.value"
                                @click="handleChangeFilter('mode', item.value)"
                            >
                                {{ item.label }}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="top-filter type">
                    <div class="filter-item" style="width: 100%">
                        <div class="filter-item_label">需求类型：</div>

                        <div :class="['filter-item_check', { collapse: typeCollapse.status && typeCollapse.value }]" ref="typeCheckListRef">
                            <div
                                :class="['check-item', { active: item.value === filter.type }]"
                                v-for="(item, index) in typeList"
                                :key="index"
                                @click="handleChangeFilter('type', item.value)"
                            >
                                {{ item.label }}
                            </div>
                        </div>

                        <div class="check-collapse" v-if="typeCollapse.status">
                            <div @click="typeCollapse.value = !typeCollapse.value">
                                <i class="el-icon-arrow-down" v-if="!typeCollapse.value"></i>
                                <i class="el-icon-arrow-up" v-else></i>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="top-filter type" v-if="filter.type !== 0">
                    <div class="filter-item" style="width: 100%">
                        <div class="filter-item_label">二级分类：</div>

                        <div :class="['filter-item_check']">
                            <div
                                :class="['check-item', { active: item.value === filter.secondType }]"
                                v-for="(item, index) in secondClassList"
                                :key="index"
                                @click="handleChangeFilter('secondType', item.value)"
                            >
                                {{ item.label }}
                            </div>
                        </div>

                        <div class="check-collapse" v-if="typeCollapse.status">
                            <div @click="typeCollapse.value = !typeCollapse.value">
                                <i class="el-icon-arrow-down" v-if="!typeCollapse.value"></i>
                                <i class="el-icon-arrow-up" v-else></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 过滤条件 -->
            <div class="container-filter">
                <div class="filter-header">
                    <div class="header-label">全部需求</div>

                    <div class="header-count">共找到{{ pageParams.total }}个结果</div>
                </div>

                <div class="filter-box flex-center">
                    <div class="filter-box_left flex-center">
                        <div class="order-item flex-center" @click="handleOrderChange('time')">
                            <div class="order-item_label" :class="{ active: filter.time_order }">发布时间</div>
                            <div class="order-item_icon flex-center">
                                <i class="el-icon-caret-top" :class="{ active: filter.time_order === 'asc' }"></i>
                                <i class="el-icon-caret-bottom" :class="{ active: filter.time_order === 'desc' }"></i>
                            </div>
                        </div>

                        <div class="order-item flex-center" @click="handleOrderChange('budget')">
                            <div class="order-item_label" :class="{ active: filter.budget.order }">价格</div>
                            <div class="order-item_icon flex-center">
                                <i class="el-icon-caret-top" :class="{ active: filter.budget.order === 'asc' }"></i>
                                <i class="el-icon-caret-bottom" :class="{ active: filter.budget.order === 'desc' }"></i>
                            </div>
                        </div>

                        <!-- 金币范围 -->
                        <div class="budget-filter flex-center">
                            <el-input-number
                                v-model="filter.budget.min"
                                :min="1"
                                :max="999999999"
                                placeholder="金币"
                                :controls="false"
                                :precision="0"
                            ></el-input-number>
                            <span>-</span>
                            <el-input-number
                                v-model="filter.budget.max"
                                :min="1"
                                :max="999999999"
                                placeholder="金币"
                                :controls="false"
                                :precision="0"
                            ></el-input-number>

                            <el-button class="primary" @click="getTaskList">确定</el-button>
                        </div>
                    </div>

                    <div class="filter-box_right flex-center">
                        <el-input v-model="filter.keyword" placeholder="搜索需求名称" style="width: 320px" clearable></el-input>
                        <el-button class="primary" @click="getTaskList">搜索</el-button>
                    </div>
                </div>
            </div>

            <template v-if="taskList.length > 0">
                <!-- 列表卡片 -->
                <div class="container-box">
                    <TaskList :task-list="taskList">
                        <template slot-scope="scope">
                            <div class="btn flex-center" :class="[getBtn(scope.task).type]" @click="handleToTask(scope.task)">
                                {{ getBtn(scope.task).label }}
                            </div>
                        </template>
                    </TaskList>
                </div>

                <!-- 分页 -->
                <div class="container-pagination">
                    <div class="list-pagination flex-center">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page.sync="pageParams.page"
                            :page-size="pageParams.page_size"
                            layout="prev, pager, next, jumper"
                            :total="pageParams.total"
                        >
                        </el-pagination>
                    </div>
                </div>
            </template>

            <div class="container-empty flex-center" v-else>
                <img src="@/assets/img/task-center/task-empty.png" alt="" />
                <span>暂无{{ currentTab === 1 ? "教师" : "企业" }}任务</span>
            </div>
        </div>
    </div>
</template>

<script>
import taskApi from "../../../apis/task";
import TaskList from "@/components/new-task/TaskList.vue";
import { isEmpty } from "@/utils/common";

export default {
    data() {
        return {
            classifyList: [], // 分类列表
            currentTab: 1,
            tabList: [
                { label: "教师任务", value: 1 },
                { label: "企业任务", value: 2 },
            ],
            statusList: [
                { label: "全部", value: 0 },
                { label: "报名中", value: 1 },
                { label: "进行中", value: 2 },
                { label: "圆满完成", value: 3 },
            ],
            modelist: [
                { label: "全部", value: 0 },
                { label: "招募", value: 1 },
                { label: "竞单", value: 2 },
            ],
            typeCollapse: {
                status: false,
                value: false,
            },
            typeList: [{ label: "全部", value: 0 }],
            filter: {
                keyword: "",
                status: 0, // 0-全部，1-报名中, 2-进行中，3-圆满完成
                type: 0, // 0-全部
                secondType: 0, // 全部
                mode: 0, // 模式：0-全部，1-招募，2-竞单
                time_order: "", // 发布时间排序，asc, desc
                budget: {
                    order: "", // 价格排序，asc, desc
                    min: undefined, // 预算下限
                    max: undefined, // 预算上限
                },
            },

            taskList: [],

            pageParams: {
                page: 1,
                page_size: 10,
                total: 0,
            },
        };
    },

    created() {
        this.getClassList();
        this.getTaskList();
    },

    components: {
        TaskList,
    },

    watch: {
        "filter.type"(val) {
            if (val === 0) {
                this.filter.secondType = 0;
            }
        },
    },

    computed: {
        filterParams() {
            const params = {
                user_type: this.currentTab,
            };

            if (this.filter.keyword) params.filter_name = this.filter.keyword;
            if (this.filter.status !== 0) params.filter_status = this.filter.status;
            if (this.filter.mode !== 0) params.filter_mode = this.filter.mode;
            if (this.filter.time_order) params.order_create_time = this.filter.time_order;
            if (this.filter.budget.order) params.order_task_budget = this.filter.budget.order;
            if (this.filter.budget.min) params.budget_min = this.filter.budget.min;
            if (this.filter.budget.max) params.budget_max = this.filter.budget.max;

            if (this.filter.type !== 0) {
                params.filter_type =
                    this.filter.secondType === 0 ? this.secondClassList.map((item) => item.value) : [this.filter.secondType];
            }

            return params;
        },

        // 二级分类列表
        secondClassList() {
            if (this.filter.type === 0) return [];

            const list = [{ label: "全部", value: 0 }];

            const classList = this.classifyList.find((item) => item.id === this.filter.type)?.subClassification || [];
            list.push(...classList.map((item) => ({ label: item.name, value: item.id })));

            return list;
        },
    },

    methods: {
        getBtn(task) {
            // 超时
            const timeExpired = Date.now() > new Date(task.task_start_time).getTime();
            const unBid = task?.task_progress > 2 && task.accepted_user_id !== Number(localStorage.getItem("id"));

            // 未中标
            if (unBid) {
                return { label: "已错失", type: "miss" };
            }

            // 没有报名或取消报名
            if (isEmpty(task?.task_todos) || task.task_todos?.todo_key <= 1) {
                // 没有记录，或者取消报名且过期-错失
                const isMiss = timeExpired && (isEmpty(task?.task_todos) || task.task_todos?.todo_key === 0);

                return isMiss ? { label: "已错失", type: "miss" } : { label: "参与需求", type: "primary" };
            }

            if (task.task_todos?.todo_key === 4) {
                return { label: "评价", type: "success" };
            }

            if (task.task_todos?.todo_key === 10) {
                return { label: "已评价", type: "miss" };
            }

            return { label: "参与需求", type: "primary" };
        },

        // 获取分类
        getClassList() {
            let params = { paging: 0, class_type: 2 };

            this.$httpStudent.axiosGetBy(this.$api.classification, params, (res) => {
                if (res.code === 200) {
                    this.classifyList = res.data?.data?.filter((item) => item.subClassification?.length > 0) || [];
                    this.typeList.push(...this.classifyList.map((item) => ({ label: item.name, value: item.id })));

                    this.$nextTick(() => {
                        this.initTypeCollapse();
                    });
                }
            });
        },

        // 初始化类型选择collapse
        initTypeCollapse() {
            const el = this.$refs.typeCheckListRef;

            if (el) {
                if (el.scrollHeight > el.clientHeight) {
                    this.typeCollapse.status = true;
                }
            }
        },

        // 切换教师企业tab
        handleChangeTab(tab) {
            if (this.currentTab === tab.value) return;

            this.currentTab = tab.value;
            this.getTaskList();
        },

        handleChangeFilter(key, val) {
            if (this.filter?.[key] === val) return;

            if (key === "type") {
                this.filter.secondType = 0;
            }

            this.filter[key] = val;
            this.getTaskList();
        },

        handleSizeChange(val) {
            console.log("page size: ", val);
        },

        handleCurrentChange(val) {
            this.pageParams.page = val;

            this.getTaskList();
        },

        // 排序变化
        handleOrderChange(type) {
            const orderMap = {
                budget: this.filter.budget.order,
                time: this.filter.time_order,
            };
            const orderList = ["", "asc", "desc"];

            const currentIndex = orderList.findIndex((item) => item === orderMap[type]);
            const nextOrder = orderList[(currentIndex + 1) % orderList.length];

            if (type === "budget") this.filter.budget.order = nextOrder;
            if (type === "time") this.filter.time_order = nextOrder;

            this.getTaskList();
        },

        getTaskList() {
            const params = {
                page: this.pageParams.page,
                page_size: this.pageParams.page_size,
                // filter_user: Number(localStorage.getItem("id")),
                ...this.filterParams,
            };

            this.$httpStudent.axiosPost(taskApi.studentTaskList, params, (res) => {
                if (res.code === 200) {
                    this.pageParams.total = res.data?.total || 0;
                    this.taskList = res.data?.list || [];
                } else {
                    this.$message.error(res.message);
                }
            });
        },

        handleToTask(task) {
            if (!isEmpty(task.task_todos) && task.task_todos.todo_key === 11) {
                this.$message.warning("需求已被下架，无法查看");
                return;
            }

            const url = this.$router.resolve({
                path: "/student/newTask/detail",
                query: {
                    id: task.id,
                },
            }).href;

            window.open(url, "_blank");
        },
    },
};
</script>

<style lang="scss" scoped>
.task-center {
    --tab-height: 52px;
    --box-height: calc(100vh - 100px);
    width: 100%;
    min-height: var(--box-height);
    display: flex;
    flex-direction: column;

    & > * {
        flex-shrink: 0;
    }

    &_tab {
        height: var(--tab-height);
        display: flex;
        // gap: 8px;

        .tab-item {
            min-width: 104px;
            display: flex;
            justify-content: center;
            align-items: center;
            // padding-inline: 20px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #37383b;
            cursor: pointer;

            &.active {
                color: #685df5;
                background-color: #ffffff;
                border-radius: 4px 4px 0px 0px;
            }
        }
    }

    &_container {
        flex: 1;
        background-color: #ffffff;
        position: relative;

        .el-button {
            height: 32px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 12px;

            &.primary {
                background: linear-gradient(270deg, #291ce7 0%, #594fed 100%);
                color: #ffffff;
            }
        }

        .container-top {
            padding: 33px 40px 24px;
            border-bottom: 1px solid #e9e9e9;

            .top-filter {
                & + .top-filter {
                    margin-top: 4px;
                }

                &.status,
                &.type {
                    .filter-item {
                        align-items: flex-start;
                    }
                }

                display: flex;
                align-items: center;
                justify-content: flex-start;
                gap: 16px;

                .filter-item {
                    display: flex;
                    align-items: center;
                    position: relative;

                    &_label {
                        flex-shrink: 0;
                        font-weight: 500;
                        font-size: 14px;
                        color: #6e7277;
                        line-height: 30px;
                    }

                    &_check {
                        --height: 28px;
                        display: flex;
                        align-items: flex-start;
                        flex-wrap: wrap;
                        gap: 4px;
                        // width: calc(100% - 85px);
                        height: var(--height);
                        overflow: hidden;

                        &.collapse {
                            height: fit-content;
                        }

                        .check-item {
                            font-family: PingFang SC, PingFang SC;
                            font-weight: 400;
                            font-size: 14px;
                            color: #666666;
                            padding: 4px 8px;
                            cursor: pointer;
                            flex-shrink: 0;

                            &.active {
                                background: #edecff;
                                border-radius: 4px;
                                color: #594fed;
                            }
                        }
                    }

                    .check-collapse {
                        position: absolute;
                        right: 0;
                        top: 0;
                        height: 28px;
                        display: flex;
                        align-items: center;
                        cursor: pointer;
                    }
                }

                .primary-button {
                    width: 88px;
                    height: 32px;
                    background: #594fed;
                    border-radius: 20px;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 500;
                    font-size: 14px;
                    color: #ffffff;
                    line-height: 30px;
                    text-align: center;
                    cursor: pointer;
                }
            }
        }

        .container-filter {
            padding: 24px 42px 40px;

            ::v-deep .el-input {
                height: 32px;

                .el-input__inner {
                    height: 32px;
                }

                .el-input__icon {
                    line-height: 34px;
                }
            }

            ::v-deep .el-input-number {
                line-height: 32px;

                .el-input__inner {
                    text-align: left;
                }
            }

            .filter-header {
                display: flex;
                align-items: center;
                justify-content: space-between;
            }

            .filter-box {
                margin-top: 16px;
                justify-content: space-between;

                &_left {
                    gap: 42px;

                    .order-item {
                        gap: 2px;
                        cursor: pointer;

                        &_label {
                            font-weight: 400;
                            font-size: 14px;
                            color: #666666;
                            user-select: none;

                            &.active {
                                color: #594fed;
                            }
                        }

                        &_icon {
                            flex-direction: column;

                            [class^="el-icon-"],
                            [class^="el-icon-"]::before {
                                font-size: 11px;
                                line-height: 8px;
                                height: 6px;
                                display: block;
                            }

                            i.active {
                                color: #594fed;
                            }
                        }
                    }

                    .budget-filter {
                        gap: 4px;

                        span {
                            color: #333333;
                        }

                        .el-button {
                            margin-left: 6px;
                            display: none;
                        }

                        &:hover {
                            .el-button {
                                display: flex;
                            }
                        }
                    }
                }

                &_right {
                    gap: 10px;
                }
            }
        }

        .container-box {
            padding-inline: 42px;
            padding-bottom: 72px;
        }

        .container-pagination {
            position: absolute;
            bottom: 20px;
            left: 0;
            width: 100%;
        }

        .container-empty {
            padding-top: 20px;
            flex-direction: column;
            gap: 20px;

            span {
                font-weight: 500;
                font-size: 14px;
                color: #666666;
            }
        }
    }
}
</style>
